import React, { useState, useEffect } from "react";
import { Popconfirm, Modal, Button, Table, Form, Input, message, Upload,Select, Checkbox } from "antd";
import axios from "axios";
import DefaultLayout from '../components/DefaultLayout';
import { DeleteOutlined, EditOutlined,UploadOutlined,CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import CloseButton from "../components/CloseButton";
import './SetCategory.css';
import imageCompression from 'browser-image-compression';
import Swal from 'sweetalert2';
import CategoryType from './../enum/categoryTypeEnum';
import config from '../config'


const CategorySetting = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;

  const [categoriesData, setCategoriesData] = useState([]);
  const [printersData, setPrintersData] = useState([]);
  const [popupModal, setPopupModal] = useState(false);
  const [editCategory, setEditCategory] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [fileUpload, setFile] = useState(null);
  const [previousImageKey, setPreviousImageKey] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [originalImage ,setOriginalImageURLEdit] = useState(null);
  const [isUploading, setIsUploading] = useState(false);  
  const [uploadTimeout, setUploadTimeout] = useState(null);
  const [loading, setLoading] = useState(false);
  var [countImageUploaded, setCountImage] = useState(0);
  const [printerStatusOpen, setPrinterStatusOpen] = useState(false);
  const [categoryStatusOpen, setCategoryStatusOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredItemsData, setFilteredItemsData] = useState([]);
  const { Search } = Input;
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handlePrinterStatusDropdownVisibleChange = (open) => {
      setPrinterStatusOpen(open);
  };

  const handleStatusCategoryDropdownVisibleChange = (open) => {
    setCategoryStatusOpen(open);
};

  const getAllCategory = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/menus/get-category`);
      setCategoriesData(data);
      setFilteredItemsData(data);
      // console.log(data);
    } catch (error) {
      message.error('Something Went Wrong');
      // console.log(error);
    }
  };

  // useEffect(() => {
  //   if(searchText){
  //     const filteredData = categoriesData.filter(item => 
  //       item.name.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //     setFilteredItemsData(filteredData);
  //   }else{
  //     setFilteredItemsData(categoriesData);
  //   }
  // }, [searchText]);

  const handleSearch = (searchValue) => {
    const lowerSearch = searchValue.toLowerCase();

    if (searchValue) {
      const filteredData = categoriesData.filter(item =>
        item.name.toLowerCase().includes(lowerSearch)
      );
      setFilteredItemsData(filteredData);
    } else {
      setFilteredItemsData(categoriesData);
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  const getAllPrinter = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
      setPrintersData(data.printerSettings);
      // console.log(data);
    } catch (error) {
      message.error('Something Went Wrong');
      // console.log(error);
    }
  };

  useEffect(() => {
    getAllPrinter();
  }, []);

  useEffect(() => {
    // This effect will run when the editCategory is set (when fetching data for editing)
    if (editCategory && editCategory.image) {
      // If there's an existing image, set it as the initial image
      const extractedFilename = editCategory.image.match(/[^/]+$/)[0];
      setImageUrl(editCategory.image);
      setPreviousImageKey(new URL(editCategory.image).pathname.slice(1)); // Extract the key from the URL
      // Initialize the fileList with the fetched image (for display in the Upload component)
      setFileList([
        {
          uid: "-1",  // Unique identifier for the file
          name: extractedFilename,  // Display name
          status: "done",  // Mark it as uploaded
          url: editCategory.image,  // Set the fetched image URL
        },
      ]);
    }
  }, [editCategory]);

  // useEffect(() => {
  //   console.log("Image", imageUrl);
  //   console.log("Original Image", originalImage);
  // }, [imageUrl, originalImage]);

  const columns = [
    {
      title: 'No',
      key: 'index',
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span> // Show continuous row number across paginated pages
      ),
    },
    {
      title: "Image",
      dataIndex: "image",
      render: (image, record) => (
        <img
          src={record.image}
          alt={record.name}
          height="50"
          width="50"
          style={{ cursor: 'pointer', borderRadius: 6, objectFit: 'cover' }}
          onClick={() => {
            setPreviewImage(record.image);
            setPreviewVisible(true);
          }}
        />
      ),
      onCell: () => ({
        style: { verticalAlign: 'top' },
      }),
    },
    { title: "Category Name", dataIndex: "name" ,
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: false,
      onCell: () => ({
        style: { verticalAlign: 'top' },
      }),
    },
    
    {
      title: "Printer",
      dataIndex: "printer",
      filters: printersData.map(p => ({ text: p.name, value: p.id })),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Checkbox.Group
            style={{ display: 'flex', flexDirection: 'column' }}
            options={printersData.map(p => ({ label: p.name, value: p.id }))}
            value={selectedKeys}
            onChange={(keys) => {
              setSelectedKeys(keys);
              confirm({ closeDropdown: false });
            }}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%', marginTop: 8 }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => {
        if (Array.isArray(record.printer)) {
          return record.printer.includes(value);
        }
        return record.printer === value;
      },
      render: (printerIds) => {
        if (!Array.isArray(printerIds)) {
          const printer = printersData.find((p) => p.id === printerIds);
          return printer ? printer.name : "Unknown Printer";
        }
        return printerIds
          .map((id) => printersData.find((p) => p.id === id)?.name || "Unknown Printer")
          .join(", ");
      },
      onCell: () => ({
        style: { verticalAlign: 'top' },
      }),
    },
    {
      title: "Priority",
      dataIndex: "priority",
      sorter: (a, b) => (parseInt(a.priority) || 0) - (parseInt(b.priority) || 0),
      showSorterTooltip: false,
      render: (priority) => {
        return priority;
      },
      onCell: () => ({
        style: { verticalAlign: 'top' },
      }),
    },
    {
      title: "Actions",
      dataIndex: "_id",
      render: (id, record) => (
        <div>
          {/* <EditOutlined
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEditCategory(record);
              setPopupModal(true);
            }}
          /> */}
          <EditOutlined
            style={{ cursor: "pointer", fontSize: 22, marginRight: 10 }}
            onClick={() => openModal(record)}
          />
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined
              style={{ cursor: "pointer",fontSize: 22, marginLeft: 8 }}
            />
          </Popconfirm>
        </div>
      ),
      onCell: () => ({
        style: { verticalAlign: 'top' },
      }),
    },
  ];

  // const deleteImageFromS3 = async (key) => {
  //   // console.log("Deleting key:", key); // Debug
  //   if (!key) {
  //     console.error("No key provided for deletion");
  //     return; // Prevent calling the API with a null/undefined key
  //   }
  //   try {
  //     // console.log("Start Perform API");
  //     // await axios.post("${apiBaseUrl}/api/delete", {
  //     //   data: { key },
  //     // });
  //     await axios.post("${apiBaseUrl}/api/image/delete", { key }, {
  //       headers: {
  //         'Content-Type': 'application/json', // Ensure JSON payload
  //       },
  //     });
  //     // console.log("Done.");
  //     // message.success("Image deleted successfully");
  //   } catch (error) {
  //     // console.error("Failed to delete image:", error);
  //     // console.error("Failed to delete image. Error:", error.response?.data || error.message);
  //     // message.error("Failed to delete image");
  //     // 
  //   }
  // };

  const openModal = (category = null) => {
    if (category) {
      setEditCategory(category); // Set the category to edit
      setImageUrl(category.image); // Set the existing image URL
      // console.log(" Image",imageUrl);
      if(category.image){
        setPreviousImageKey(new URL(category.image).pathname.slice(1)); // Extract S3 key from URL
      }
      
      setOriginalImageURLEdit(category.image);
      // console.log("Original Image",originalImage);
      // Populate the fileList with the existing image
      setFileList([
        {
          uid: "-1", // Unique identifier for the file
          name: "Existing Image", // Display name
          status: "done", // Mark it as uploaded
          url: category.image, // Existing image URL
        },
      ]);
    } else {
      setEditCategory(null); // For adding a new category
      setImageUrl(null); // Clear image URL
      setPreviousImageKey(null); // Clear the previous image key
      setOriginalImageURLEdit(null);
      setFileList([]); // Clear the file list
    }
    
    setPopupModal(true); // Open the modal
  };
  const formatEnumLabel = (value) =>
    value
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
      
  const handleDelete = async (record) => {
    try {
      await axios.post(`${apiBaseUrl}/api/menus/delete-category`, { categoryId: record._id });
      // message.success('Category Deleted Successfully');
      Swal.fire({
        title: 'Deleted!',
        text: 'Category Deleted Successfully',
        icon: 'success',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
      getAllCategory();
      setPopupModal(false);
    } catch (error) {
      // message.error('Something Went Wrong');
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something Went Wrong',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };

  const handleCancel = async () => {
    // Prevent canceling if upload is still in progress
    if (isUploading) {
      // message.error("Please wait until the image upload before canceling.");
      Swal.fire({
        icon: 'error',
        title: 'Wait',
        text: 'Please wait until the image upload before canceling.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
      return;
    }

    if (loading) {
      // message.warning("Proceed submitting...");
      Swal.fire({
        icon: 'warning',
        title: 'Please wait',
        text: 'Proceed submitting...',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
      return;
    }

    // try {
      
    // } catch (error) {
    //   message.error("Something went wrong.");
    // } finally {
      // Reset states after canceling
      // setCountImage(0);
      setOriginalImageURLEdit(null);
      setFile(null);
      setImageUrl(null);
      setFileList([]);
      setEditCategory(null); // Clear the edit state
      setPopupModal(false); // Close the modal
    // }
  };
  
  const handleSubmit = async (values) => {
    if (isUploading) {
      // message.warning("Please wait until the upload is complete before submitting your form.");
      Swal.fire({
        icon: 'warning',
        title: 'Wait',
        text: 'Please wait until the upload is complete before submitting your form.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
      return false; // Prevent form submission while uploading
    }
  
    setLoading(true); 

    const updatedValues = { ...values, slug: values.name, image: imageUrl };
    try {

      if (editCategory === null) {
        const dateTime = new Date();
        const createdAt = dateTime.toLocaleString();
        const newValues = { ...updatedValues, createdAt };
  
        if(fileUpload !== null){
        //  Only upload image to S3 when submitting
        console.log("First see URL:", fileUpload);
        try {
          const uploadedImageUrl = await uploadImageToS3(fileUpload);
          newValues.image = uploadedImageUrl;
        } catch (uploadError) {
          // If image upload fails, clear the file list and stop submission
          // message.error("Image upload failed. Please try again.");
          Swal.fire({
            icon: 'error',
            title: 'Upload Failed',
            text: 'Image upload failed. Please try again.',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });
          setLoading(false); 
          setFile(null);
          setFileList([]); // Clear the file list
          return; // Stop the submission process
          }
        }      
  
        await axios.post(`${apiBaseUrl}/api/menus/add-category`, newValues);
        // message.success('Category Added Successfully');
        Swal.fire({
          title: 'Success',
          text: 'Category Added Successfully',
          icon: 'success',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      } else {
        const updatedValuesWithImage = { ...updatedValues, categoryId: editCategory._id };
  
        // console.log(imageUrl);
        // console.log(originalImage);
        // If image URL has changed, upload new image to S3 and remove old image
        if (imageUrl !== originalImage && imageUrl != null) {
          
          try {
            updatedValuesWithImage.image = await uploadImageToS3(fileUpload);
          } catch (uploadError) {
            // If image upload fails, clear the file list and stop submission
            message.error("Image upload failed. Please try again.");
            setLoading(false); 
            setFile(null);
            setFileList([]); // Clear the file list
            return; // Stop the submission process
          }
        }else{
          updatedValuesWithImage.image = originalImage;
        }
  
        // If image is not set, keep the original
      
        // if (!imageUrl && originalImage) {
        //   updatedValuesWithImage.image = originalImage; // Keep original image URL
        // } else {
        //   updatedValuesWithImage.image = await uploadImageToS3(imageUrl); // Upload new image
        // }
  
        await axios.put(`${apiBaseUrl}/api/menus/edit-category`, updatedValuesWithImage);
        // message.success('Category Updated Successfully');
        Swal.fire({
          title: 'Success',
          text: 'Category Updated Successfully',
          icon: 'success',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        });
      }
  
      setImageUrl(null); // Clear the image after submission
      setFileList([]); // Clear the file list
      // setCountImage(0);
      getAllCategory(); // Refresh category list
      setPopupModal(false); // Close the modal
      setEditCategory(null); // Reset edit category
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something Went Wrong',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
    }
    finally{
      setLoading(false); 
    }

  };

  const handleImageUpload = async (file) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      message.error("Invalid file type. Only JPG, JPEG, and PNG are allowed.");
      return;
    }
    
    // Check if file size exceeds 20MB
    if (file.size > 20 * 1024 * 1024) {
      message.error("File size exceeds 20MB limit. Please choose a smaller file.");
      return;
    }
  
    // Initialize the file with status 'uploading' and 0% progress for preview purposes
    setFileList((prevList) => [
      ...prevList,
      {
        uid: file.uid,
        name: file.name,
        status: "uploading", // Image is uploading
        percent: 0,          // Set progress to 0 initially
      },
    ]);
  
    setIsUploading(true); // Set uploading to true
  
    // Compress the image before upload
    const options = {
      maxSizeMB: 1, // Adjust compression size (1MB target)
      maxWidthOrHeight: 1920, // Optionally resize to max dimensions
      useWebWorker: true,
    };
  
    let compressedFile;
    let timeout;
  
    try {
      compressedFile = await imageCompression(file, options);
    } catch (err) {
      message.error("Image compression failed.");
      setIsUploading(false);
      return;
    }
  
    try {
      // Create a local object URL for preview purposes
      const localUrl = URL.createObjectURL(compressedFile);
      setImageUrl(localUrl); // Set the image URL for preview
      setFile(compressedFile);
  
      setFileList((prevList) =>
        prevList.map((item) =>
          item.uid === file.uid ? { ...item, status: "done", url: localUrl } : item
        )
      );
      // message.success("Image ready for upload!");
  
      // Start a timeout for the upload process
      timeout = setTimeout(() => {
        message.error("Upload is taking too long. Please try again.");
        setIsUploading(false);
        setFileList((prevList) =>
          prevList.map((item) =>
            item.uid === file.uid ? { ...item, status: "error" } : item
          )
        );
      }, 30000); // 30 seconds timeout
      setUploadTimeout(timeout); // Store the timeout ID
    } catch (error) {
      message.error("Image upload failed! Please try again.");
      setFileList((prevList) =>
        prevList.map((item) =>
          item.uid === file.uid ? { ...item, status: "error" } : item
        )
      );
    } finally {
      // Ensure timeout is cleared after handling the upload result
      if (timeout) {
        clearTimeout(timeout);
      }
      setIsUploading(false); // Reset uploading status
    }
  };
  
  const uploadImageToS3 = async (file) => {
    try {
      const formData = new FormData();
      formData.append("image", file); // Append the file object directly
  
      const response = await axios.post(`${apiBaseUrl}/api/image/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
  
      if (response.data && response.data.url) {
        // message.success("Image uploaded successfully!");
        return response.data.url; // Return the URL of the uploaded image
      } else {
        // If the response is invalid or does not contain the URL
        throw new Error("Failed to upload image. Please try again.");
      }
    } catch (error) {
      // message.error(error.response?.data?.message || "Image upload failed. Please try again.");
      console.error("Image upload error:", error);
      throw error; // Re-throw the error to be caught in the outer try-catch
    }
  };

  return (
    <DefaultLayout searchPlaceholder="Category Name" onSearch={handleSearch}>
      <div className={`set-category-wrapper${popupModal ? ' blur-background' : ''}`}>
        <div className="page-header">
          <h1 className="page-title">Category</h1>
          <Button type="primary" onClick={() => openModal()}>
            Add Category
          </Button>
        </div>

      {/* <div>
        <h1>Category List</h1>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Search
            placeholder="Search"
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 200 }}
            allowClear  
          />
          <Button type="primary" onClick={() => openModal()}>Add Category</Button>
        </div>
      </div> */}

        <Table columns={columns} dataSource={filteredItemsData} bordered 
          //add pagination
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: filteredItemsData.length > 10,
            showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
            onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
          }} 
        />
      </div>
      {/* Modals outside the blurred wrapper so they are not blurred */}
      {popupModal && (
        <Modal
          title={
            <div>
                {editCategory !== null ? 'Edit Category' : 'Add New Category'}
                <CloseButton onClick={handleCancel } />
            </div>
          }
          open={popupModal}
          onCancel={handleCancel}
          footer={false}
        >
          <Form layout="vertical" initialValues={editCategory == null ? {priority: 99} : editCategory } onFinish={handleSubmit}>
            <Form.Item
              name="name"
              label="Category Name"
              rules={[{ required: true, message: 'Please input the category name!' }]}
            >
              <Input />
            </Form.Item>

              <Form.Item
              name="type"
              label="Category Type"
              rules={[{ required: true, message: 'Please select the category type!' }]}
              >
                <Select
                onDropdownVisibleChange={handleStatusCategoryDropdownVisibleChange } 
                suffixIcon={categoryStatusOpen  ? <CaretUpOutlined /> : <CaretDownOutlined />} 
                >
                  {Object.values(CategoryType).map((type) => (
                    <Select.Option key={type} value={type}>
                      {formatEnumLabel(type)}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="image"
                label="Image Upload"
              >
                {/* handle previous image */}
                <Upload
                  className="upload-container"
                  listType="picture"
                  fileList={fileList}
                  customRequest={({ file }) => handleImageUpload(file)}
                  onRemove={async (file) => {
                    if (isUploading) {
                      message.warning("Please wait until the upload is complete before removing the file.");
                      return false; // Prevent the removal
                    }

                    if(file.url && editCategory){
                      setFileList([]);
                    }
                    // if (file.url && previousImageKey &&!editCategory) {
                    //   try {
                    //     // console.log("Deleting previous image key:", previousImageKey);
                    //     await deleteImageFromS3(previousImageKey);
                    //     setPreviousImageKey(null);
                    //     // message.success("Image removed successfully!");
                    //   } catch (error) {
                    //     // console.error("Failed to delete image:", error);
                    //     // message.error("Failed to remove image.");
                    //   }
                    // }
                    setFile(null);
                    setFileList([]);
                    setImageUrl(null);
                  }}
                >
                  {fileList.length < 1 && <Button  icon={<UploadOutlined />} className="upload-button">Upload Image</Button>}
                </Upload>
              </Form.Item>

              <Form.Item
              name="printer"
              label="Printer"
              rules={[{ required: true, message: 'Please select the printer!' }]}
              >
                <Select
                  mode="multiple"
                  onDropdownVisibleChange={handlePrinterStatusDropdownVisibleChange}
                  suffixIcon={printerStatusOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                  className="custom-multiple-select"
                >
                  {printersData.map((printer) => (
                    <Select.Option key={printer.id} value={printer.id}>
                      {printer.name}
                    </Select.Option>
                  ))}
                </Select>

              </Form.Item>

            <Form.Item name="priority"
            label="Priority"
            rules={[{ required: true, message: 'Please input the priority!' }]}
            initialValue={99} 

            >
              <Input type="number" min={1} max={99} placeholder="1-99" />
            </Form.Item>

              <div className="d-flex justify-content-end ant-modal-footer">
                {/* <Button type="primary" htmlType="submit">
                  Save
                </Button> */}
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}  // Show loading spinner
                  iconPosition="start"  // Ensure the icon is positioned at the start
                  disabled={loading}  // Disable the button while loading
                >
                  Save
                </Button>
              </div>
            </Form>
          </Modal>
        )
      }
      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
        transitionName=""  // 禁用动画
        maskTransitionName=""  // 禁用遮罩动画
        width={400}
        bodyStyle={{ 
          padding: 0, 
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 400,
        }}
        style={{
          top: '30%',  // 确保 Modal 整体居中
          transform: 'translateY(-10%)',  // 修正垂直偏移
          opacity: previewVisible ? 1 : 1, // 避免淡入动画
          pointerEvents: previewVisible ? 'auto' : 'none',
        }}
      >
        <img
          alt="category"
          style={{ 
            width: '100%', 
            maxWidth: 400, 
            maxHeight: 400, 
            objectFit: 'contain', 
            display: 'block'
          }}
          src={previewImage}
        />
      </Modal>
    </DefaultLayout>
  );
};

export default CategorySetting;
